// extracted by mini-css-extract-plugin
export default {"footerLinks":"Footer_footerLinks__Iah4o"};